import { IContentSource } from ".";

export class FileHeader {
  id: string;
  name: string;
  size: number;
  createDateTime: Date;
  createUserCode: string;
  source: IContentSource;
}
